// John Eldhose 20180822
import { RestfulPost } from './Restful';

export async function deleteAddress(data) {
  const addr = await RestfulPost('deleteAddress', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return addr;
}



// WEBPACK FOOTER //
// ./src/Api/deleteAddress.js